import localize from './localize'
export default localize



// WEBPACK FOOTER //
// ./src/higherOrderComponents/localize/index.js